import styled from 'styled-components';
import { apiUrl } from '../../config/api';

function GoogleIcon() {
  return <svg viewBox="0 0 18 18" aria-hidden="true">
    <path fill="#EA4335" d="M17.64 9.205c0-.638-.057-1.252-.164-1.841H9v3.482h4.844a4.14 4.14 0 0 1-1.797 2.716v2.258h2.909c1.702-1.567 2.684-3.874 2.684-6.615Z" />
    <path fill="#4285F4" d="M9 18c2.43 0 4.468-.806 5.956-2.18l-2.909-2.258c-.806.54-1.835.859-3.047.859-2.344 0-4.328-1.585-5.037-3.714H.956v2.333A9 9 0 0 0 9 18Z" />
    <path fill="#FBBC05" d="M3.963 10.707A5.41 5.41 0 0 1 3.682 9c0-.592.102-1.168.281-1.707V4.96H.956A9 9 0 0 0 0 9c0 1.452.347 2.827.956 4.04l3.007-2.333Z" />
    <path fill="#34A853" d="M9 3.579c1.322 0 2.508.454 3.441 1.346l2.581-2.581C13.464.892 11.426 0 9 0A9 9 0 0 0 .956 4.96l3.007 2.333C4.672 5.164 6.656 3.579 9 3.579Z" />
  </svg>;
}

export default function SocialAuthButtons({ returnTo = '/client', disabled = false }) {
  const start = (provider) => {
    if (disabled) return;
    const query = new URLSearchParams({ returnTo });
    window.location.assign(apiUrl(`/api/auth/oauth/${provider}/start?${query}`));
  };

  return <Wrap aria-label="Acceso rápido">
    <Button type="button" onClick={() => start('google')} disabled={disabled}><GoogleIcon/><span>Continuar con Google</span></Button>
  </Wrap>;
}

const Wrap=styled.div`display:grid;grid-template-columns:1fr;`;
const Button=styled.button`min-height:52px;padding:0 18px;border:1px solid #747775;border-radius:10px;background:#fff;color:#1f1f1f;display:flex;align-items:center;justify-content:center;gap:12px;font-family:Roboto,Arial,sans-serif;font-size:.9rem;line-height:1.2;font-weight:500;letter-spacing:.01em;cursor:pointer;transition:background-color .2s,border-color .2s,box-shadow .2s;&:hover:not(:disabled){background:#f8faff;border-color:#747775;box-shadow:0 1px 2px rgba(60,64,67,.3),0 1px 3px 1px rgba(60,64,67,.15)}&:focus-visible{outline:3px solid rgba(66,133,244,.28);outline-offset:2px}&:active:not(:disabled){background:#eef3fe}&:disabled{background:#f1f3f4;border-color:#dadce0;color:#9aa0a6;cursor:not-allowed}svg{width:18px;height:18px;flex:0 0 auto}`;
